import React, { useContext, useEffect, useState } from "react";
import Styles from "./styles/Styles";
import { fonts, SVG } from "../../config";
import { Add, ExpandMore } from "@material-ui/icons";
import { customModal } from "../../components/modals/utils";
import ModalRegistry from "./components/ModalRegistry";
import { HiPencil } from "react-icons/hi2";
import {
  ButtonMenu,
  ContentFeedback,
  CustomText,
  ImoveisChipList,
  Pagination,
  Table,
} from "../../components";
import { BsPersonFillSlash } from "react-icons/bs";
import Filters from "./components/Filters";
import { hooks, masks } from "../../utils";
import { api } from "../../services";
import { StorageContext } from "../../contexts/StorageContext";
import { create } from "domain";

export interface PlaceProps {
  name: string;
  id: string;
}

export interface TenantProps {
  cpf?: string;
  createdAt?: string;
  email?: string;
  id?: string;
  name?: string;
  newReservation?: boolean;
  role?: string;
  places?: PlaceProps[];
}

export interface PlaceListProps {
  label: string;
  value: string;
  params: { type: string, value: string };
}

export default function RegisterTenant() {
  const [isMounted, setMount] = React.useState<boolean>(false);
  const [page, setPage] = React.useState<number>(1);
  const [filters, setFilters] = React.useState<TenantProps[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const { getData } = useContext<any>(StorageContext);
  const condominiumId = getData("company_type");
  const { loading, call } = hooks.useRequest();
  const placesList = hooks.usePlacesList(condominiumId);
  const [tenantList, setTenantList] = useState<TenantProps[]>([]);

  const Mount = React.useCallback(() => {
    filterManager(null, 1);
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  const filterManager = (
    filterData?: any | null,
    page?: number
  ) => {
    // Define como enviar pelo prop "name" do componente Filter 
    // ex: <Input name="guestEmail" label="E-mail" placeholder="E-mail" />
    // alterar para padrão (Ver RegisterReservation.tsx) caso necessário
    const filtredPlaceId = filterData?.placeIds ? filterData?.placeIds.filter((place) => place.value !== "all").map((place) => place.value) : null;
    let filters = {
      page: page ? page - 1 : 0,
      size: 10,
      condominiumId: condominiumId,
      ...(filterData?.name && { name: filterData.name }),
      ...(filterData?.email && { email: filterData.email }),
      ...(filterData?.cpf && { cpf: filterData.cpf }),
      ...(filterData?.placeIds && { placeIds: filtredPlaceId.join(",") }),
    };

    call(
      null,
      api.getTenant(filters),

      (response) => {
        if (response.ok) {
          const tl: TenantProps[] = [];
          for (const tenant of (response.data.content as TenantProps[])) {
            tl.push({
              id: tenant.id,
              name: tenant.name,
              email: tenant.email,
              cpf: tenant.cpf,
              newReservation: tenant.newReservation,
              role: tenant.role,
              createdAt: tenant.createdAt,
              places: tenant.places,
            });
          }
          console.log(tl);
          setTenantList(tl);
          setTotalPages(response.data.totalPages);
          setPage(page ? page : 0);
          setFilters(filterData);
        }
      }
    );
  };

  // function deleteTenant(tenandId) {
  //   call(
  //     null,
  //     api.deleteTenant({
  //       id: tenandId,
  //     }),
  //     async (response) => {
  //       if (response.ok) {
  //         filterManager(null, 1);
  //       }
  //     }
  //   );
  // }

  const openRegisterModal = () => {
    customModal.setInfos(
      "Cadastrar Inquílino",
      [],
      null,
      null,
      <ModalRegistry placeList={placesList} onSubmit={() => Mount()} />,
      false,
      true,
      <SVG.Maintenance />
    );
  };

  const openEditModal = (data) => {
    customModal.setInfos(
      "Editar Dados do Inquílino",
      [],
      null,
      null,
      <ModalRegistry placeList={placesList} data={data} onSubmit={() => Mount()} />,
      false,
      true,
      <HiPencil />
    );
  };

  // const RevokeModalAccess = (id: string) => {
  //   console.log(id);
  //   customModal.setInfos(
  //     "Revogar Acesso",
  //     ["Continuar e revogar acesso deste inquílino?"],
  //     {
  //       label: "Sim, Revogar",
  //       onClick: () => {
  //         deleteTenant(id);
  //         customModal.close();
  //       },
  //     },
  //     {
  //       label: "Voltar",
  //       onClick: () => {
  //         customModal.close();
  //       },
  //     },
  //     null,
  //     null,
  //     null,
  //     <BsPersonFillSlash />
  //   );
  // };

  const getButtons = (item: any): any[] => {
    return [
      {
        label: "Editar Dados do Inquílino",
        icon: HiPencil,
        onClick: () => openEditModal(item),
      },
      // { Call não existe no back - alinhar com Sena e Mauricio
      //   label: "Revogar Acesso",
      //   icon: BsPersonFillSlash,
      //   onClick: () => RevokeModalAccess(item.id),
      // },
    ];
  };

  return (
    <>
      <Styles.PageNameContainer>
        <Styles.PageNameContent>
          <CustomText fontSize={2} textColor="#FFFFFF" fontFamily={fonts.bold}>
            Cadastrar Inquílino
          </CustomText>
          <CustomText
            style={{ paddingRight: "8px" }}
            fontSize={1.75}
            textColor="#FFFFFF"
            fontFamily={fonts.regular}
          >
            Alguns dados básicos serão solicitados para o cadastro de um novo
            inquílino.
          </CustomText>
        </Styles.PageNameContent>
        <Styles.RegitryButtonSecond
          startIcon={<Add />}
          fullWidth={false}
          onClick={() => openRegisterModal()}
        >
          Cadastrar
        </Styles.RegitryButtonSecond>
      </Styles.PageNameContainer>

      <Styles.ContainerFilter>
        <CustomText
          style={{ paddingBottom: "8px" }}
          fontSize={2}
          textColor="#4D585A"
          fontFamily={fonts.bold}
        >
          Filtrar Inquílinos Cadastrados
        </CustomText>
        <Filters
          onSubmit={(data) => {
            filterManager(data, 1);
          }}
          loading={false}
          placeList={placesList}
        />
      </Styles.ContainerFilter>

      <Styles.Container>
        <CustomText
          style={{ paddingBottom: "8px" }}
          fontSize={2}
          textColor="#4D585A"
          fontFamily={fonts.bold}
        >
          Lista de Inquílinos Cadastrados
        </CustomText>
        <ContentFeedback data={tenantList} loading={loading}>
          <Table
            lastAlign={false}
            data={tenantList}
            renderItemColumns={(item) => [
              item?.name,
              <ImoveisChipList items={item.places.map((place) => place.name)} />,
              masks.CPF(item?.cpf),
              item?.email,
              null,
              <ButtonMenu endIcon={<ExpandMore />} buttons={getButtons(item)}>
                Opções
              </ButtonMenu>,
            ]}
            headers={{
              table: [
                "NOME COMPLETO",
                "IMÓVEL",
                "DOCUMENTO",
                "E-MAIL",
                "",
                "AÇÃO",
              ],
              keys: [],
            }}
          />
          <Pagination
            style={{ padding: "16px 20px", paddingTop: 0 }}
            page={page}
            totalPages={totalPages}
            setPage={(number) => filterManager(filters, number)}
          />
        </ContentFeedback>
      </Styles.Container>
    </>
  );
}
